import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { AnswerList } from '../../components/AnswerList';
import { WideButton } from '../../components/WideButton';
import { getQuestionById } from '../../selectors/questions';
import { AnswerItemContainer } from '../AnswerItem';
import { loadQuestionAnswers } from '../../actions/questionAnswers';

interface IAnswerListContainerProps {
  questionId: string;
  inPopup?: boolean;
}

export function AnswerListContainer({ questionId, inPopup }: IAnswerListContainerProps): React.JSX.Element {
  const dispatch = useDispatch();
  const { answers, hasMoreAnswers, answersPage } = useSelector(getQuestionById(questionId));

  const onLoadMoreClick = React.useCallback(() => {
    dispatch(
      loadQuestionAnswers({
        questionId,
        page: answersPage + 1,
      }),
    );
  }, [dispatch, questionId, answersPage]);

  return (
    <AnswerList
      more={
        hasMoreAnswers && (
          <WideButton testId="MoreAnswers" onClick={onLoadMoreClick}>
            Показать ещё
          </WideButton>
        )
      }
    >
      {answers.map(id => (
        <AnswerItemContainer id={id} key={id} inPopup={inPopup} />
      ))}
    </AnswerList>
  );
}
